import React from 'react'

const Nodejs_Coding_Pratice_1 = () => {
  return (
    <div>
      <h1>Coding Pratice 1</h1>
    </div>
  )
}

export default Nodejs_Coding_Pratice_1
